(function () {
  'use strict'

  require('./config')

  var MODULE_NAME = 'thismoment.config'

  angular
    .module(MODULE_NAME, [
      'thismoment.config.core'
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/config/index.js